import type { BoardColumn, OrderBoardResponse, OrderSummaryDTO } from '@scan2eat/shared';
import { COLUMN_BY_STATUS } from '@scan2eat/shared';

/** Nombre maximal de commandes affichees dans la colonne COMPLETED. Voir docs/04, section 8. */
export const DONE_COLUMN_LIMIT = 20;

/**
 * Replace une commande dans le kanban apres un evenement temps reel.
 * Fonction pure, testee sans rendu React.
 */
export function placeOrderInColumns(
  columns: OrderBoardResponse['columns'],
  order: OrderSummaryDTO,
): OrderBoardResponse['columns'] {
  const others: OrderSummaryDTO[] = [];
  for (const key of Object.keys(columns) as BoardColumn[]) {
    for (const o of columns[key]) {
      if (o.id !== order.id) others.push(o);
    }
  }

  const next: OrderBoardResponse['columns'] = {
    NEW: [], IN_PROGRESS: [], READY: [], SERVED: [], COMPLETED: [],
  };
  for (const key of Object.keys(next) as BoardColumn[]) {
    next[key] = others.filter((o) => COLUMN_BY_STATUS[o.status] === key);
  }

  // Une commande annulee n'a pas de colonne : elle quitte le tableau et se
  // consulte dans l'historique. Voir docs/adr/0011.
  const target = COLUMN_BY_STATUS[order.status];
  if (target) next[target] = [order, ...next[target]];

  next.COMPLETED = next.COMPLETED.slice(0, DONE_COLUMN_LIMIT);
  return next;
}

/** Anciennete formatee en mode court (ex: "45s", "1min", "2h05"). */
export function formatAge(placedAt: string, nowMs: number): string {
  const s = Math.max(0, Math.floor((nowMs - new Date(placedAt).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  const min = Math.floor(s / 60);
  if (min < 60) return `${min}min`;
  const h = Math.floor(min / 60);
  const remMin = min % 60;
  return `${h}h${String(remMin).padStart(2, '0')}`;
}

/** Anciennete en minutes fractionnaires, jamais negative. */
export function ageMinutes(placedAt: string, nowMs: number): number {
  return Math.max(0, (nowMs - new Date(placedAt).getTime()) / 60000);
}
